import React from "react";
import MuiDivider, { DividerProps } from "@material-ui/core/Divider";

/**
 * Material-UI v4 Divider wrapper to replace material-ui/Divider (v0)
 *
 * This wrapper provides a drop-in replacement for the old Material-UI v0 Divider
 * while using the new @material-ui/core v4 implementation with proper TypeScript types.
 */

export interface DividerWrapperProps extends DividerProps {
    // Add any additional props specific to our wrapper here if needed
}

export const Divider: React.FC<DividerWrapperProps> = (props) => {
    return <MuiDivider {...props} />;
};
